import { render, staticRenderFns } from "./gameResultFreeSlotsTab.vue?vue&type=template&id=8cf34830&lang=pug"
import script from "./gameResultFreeSlotsTab.vue?vue&type=script&lang=js"
export * from "./gameResultFreeSlotsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports